<template>
  <div>
    <el-button type="primary"
               icon="el-icon-plus"
               size="small"
               style="float: right"
               @click="onCreateButtonClick">
      {{ $t('newSpecialOffer') }}
    </el-button>
    <popup-add-special-offer-component
      :visible="isPopupAddSpecialOfferVisible"
      :hotel-list="hotelList"
      @onClose="isPopupAddSpecialOfferVisible = false"
      @onSelectedHotel="onCreateSpecialOffer">
    </popup-add-special-offer-component>
  </div>
</template>

<script>
import i18nMessages from '@/translations/SpecialOffer/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { COMPANY_TYPE } from '@/configs/constant'
import PopupAddSpecialOfferComponent from '@/views/SpecialOffer/components/ManageSpecialOffer/PopupAddSpecialOfferComponent'

export default {
  name: 'ContractCreateButtonComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { PopupAddSpecialOfferComponent },
  i18n: { messages: i18nMessages },
  props: {
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isPopupAddSpecialOfferVisible: false
    }
  },
  methods: {
    onCreateButtonClick: async function () {
      const companyData = LocalStorageFactory.getCompanyDetail()

      if (companyData.companyType === COMPANY_TYPE.STANDALONE) {
        const hotelId = await this.$store.getters['general/getActiveHotelId']
        return this.onCreateSpecialOffer(hotelId)
      }

      this.isPopupAddSpecialOfferVisible = true
    },
    onCreateSpecialOffer: function (hotelId) {
      this.$emit('onCreateSpecialOffer', hotelId)
    }
  }
}
</script>

<style scoped>

</style>
